import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { colors, combineStyles } from '@blend/consumer-components';
import { notificationTextStyle } from '../styles';

const styles = StyleSheet.create({
  success: combineStyles(notificationTextStyle, {
    color: colors.grass,
  }),
});

const Success = ({ successText, successId }: { successText: string; successId?: string }) => {
  const successProps = successId ? { id: successId } : /* istanbul ignore next: (UI-5482) */ {};
  return (
    <span className={css(styles.success)}>
      <span data-it="Success-text" {...successProps}>
        {successText}
      </span>
    </span>
  );
};

export default Success;
